<template lang="pug">
  main.main.main_book-video
    header.main__header
      h1.main__title {{ $t('bookVideo.title') }}
    .main__container
      .main__content
        form.form.form_book-video(@submit.prevent="submitForm")
          ul.main__steps(:class="{'main__steps_relative': showChooseTime}")
            li.main__step(:class="{'main__step_active': !showChooseTime}") {{ $t('bookVideo.step1') }}
            li.main__step(:class="{'main__step_active': showChooseTime}") {{ $t('bookVideo.step2') }}
          template(v-if='!showChooseTime')
            .form__radios
              .radio.radio_messages.form__radio
                input#viber.radio__input(
                  type='radio',
                  value='viber',
                  v-model='fields.messenger'
                )
                label.radio__label(for='viber')
                  h3.radio__text {{ $t('bookVideo.texts.viber') }}
                  .radio__wrap-img
                    img(src='../../../static/img/viber.png', alt='viber logo')
                .radio__more(v-if="fields.messenger === 'viber'")
                  .form__field
                    label.form__label(for='viber-phone') {{ $t('bookVideo.labels.viber') }}
                    input#viber-phone.form__input(v-model='$v.viber.$model', @input='setMessengerText($event.target.value)', name='viber', type='tel', :class='status($v.viber)', :placeholder="$t('bookVideo.placeholders.viber')", v-mask="'+380 ## ### ## ##'")
                    span.form__error-text(v-if='$v.viber.$error') {{ $t('bookVideo.errors.viber') }}
              .radio.radio_messages.form__radio
                input#telegram.radio__input(
                  type='radio',
                  value='telegram',
                  v-model='fields.messenger')
                label.radio__label(for='telegram')
                  h3.radio__text {{ $t('bookVideo.texts.telegram') }}
                  .radio__wrap-img
                    img(src='../../../static/img/telegram.png', alt='viber logo')
                .radio__more(v-if="fields.messenger === 'telegram'")
                  TextInput(
                    :label="$t('bookVideo.telegram.label')"
                    :error="$v.telegram.$error"
                    :errorText="$t('bookVideo.errors.telegram')"
                    :value="$v.telegram.$model"
                    v-on:change-input="(e) => {setMessengerText(e)}"
                  )
              .radio.radio_messages.form__radio
                input#messenger.radio__input(
                  type='radio',
                  value='messenger',
                  v-model='fields.messenger')
                label.radio__label(for='messenger')
                  h3.radio__text {{ $t('bookVideo.texts.messenger') }}
                  .radio__wrap-img
                    img(src='../../../static/img/messenger.png', alt='viber logo')
                .radio__more(v-if="fields.messenger === 'messenger'")
                  .form__field
                    TextInput(
                      :label="$t('bookVideo.labels.messenger')"
                      :error="$v.messenger.$error"
                      :errorText="$t('bookVideo.errors.messenger')"
                      :value="$v.messenger.$model"
                      v-on:change-input="(e) => {setMessengerText(e)}"
                    )
            .form__imei
              TextInput(
                :label="$t('bookVideo.labels.imei')"
                :error="$v.serialNumber.$error"
                :errorText="$t('bookVideo.errors.messenger')"
                :value="$v.serialNumber.$model"
                v-on:change-input="(e) => {setImeiText(e)}"
              )
            .main__nav
              router-link.main__link-back.link-back(to='service-product-support', href='') {{ $t('bookVideo.back') }}
              button.button(@click.prevent='showChooseTime = !showChooseTime', :disabled='!(!!fields.messenger && !$v[fields.messenger].$invalid && !$v.serialNumber.$invalid)') {{ $t('bookVideo.button') }}
          template(v-else)
            .form__checkboxes-day
              .checkbox.checkbox_day.form__checkbox-day(v-for="day in loadData", :key='day.code')
                input.checkbox__input(:id="day.code", type='radio',
                  @change='setDay($event.target.value)',
                  :value='day.code', name='week'
                  :checked="fields.date === day.code"
                )
                label.checkbox__label(:for="day.code") {{ day.title }}
            h4.form__title {{ $t('bookVideo.time.title') }}
            .form__checkboxes-time
              .checkbox.checkbox_time.form__checkbox-time(v-for="time in timesOfDay", :key='time.code')
                input.checkbox__input(:id="time.code", type='radio', v-model='fields.time', :value='time.code', name='time')
                label.checkbox__label(:for="time.code") {{ time.title }}
            footer.form__footer
              input.button.form__submit(type='submit', :value="this.info ? $t('bookVideo.change') : $t('bookVideo.submit')", :disabled='$v.fields.$invalid')
              a.main__link-back.link-back(@click="showChooseTime = !showChooseTime") {{ $t('bookVideo.back') }}
</template>

<script>
import { required, helpers } from 'vuelidate/lib/validators'
import { mask } from 'vue-the-mask'
import { mapGetters } from 'vuex'
import { api } from '@/store/http-common'
import { TextInput } from '@/components/TextInput'
import objectToFormData from 'object-to-formdata'
const alpha = helpers.regex('+38 044 555 55 55', /^\+380 \d{2} \d{3} \d{2} \d{2}$/)
// eslint-disable-next-line
const telegram = helpers.regex('@cactus', /[+\s0-9]{10,32}$|(^@[\sa-zA-Z0-9]{5,32}$)/i)

export default {
  name: 'bookVideo',
  props: ['info'],
  directives: {
    mask
  },
  data () {
    return {
      fields: {
        time: undefined,
        date: undefined,
        messenger: undefined,
        login: ''
      },
      showChooseTime: false,
      viber: undefined,
      messenger: undefined,
      telegram: '',
      loadData: {},
      timesOfDay: [],
      serialNumber: undefined
    }
  },
  created () {
    this.fetchData()
  },
  validations: {
    viber: {
      required,
      alpha
    },
    messenger: {
      required
    },
    telegram: {
      required,
      telegram
    },
    serialNumber: {
      required
    },
    fields: {
      time: {
        required
      },
      date: {
        required
      }
    }
  },
  methods: {
    async fetchData () {
      if (this.info) {
        this.fields.messenger = this.info.messenger
        this.setMessengerText(this.info.login)
      }
      /**
       * Load days and times
       * @response {object} Object of days and times
       */
      api
        .post('/ajax.php?action=sg:service.api.videocall.loadData')
        .then(response => {
          // convert array => object
          response.data.data.days.forEach(day => {
            this.loadData[day.code] = day
          })

          // set active day
          this.setDay(response.data.data.days[0].code)
        })
    },
    status (validation) {
      return {
        form__input_error: validation.$error,
        dirty: validation.$dirty
      }
    },
    setMessengerText (value) {
      this.fields.login = value
      this[this.fields.messenger] = value
      this.$v[this.fields.messenger].$touch()
    },
    setImeiText (value) {
      this.serialNumber = value
      this.$v.serialNumber.$touch()
    },
    setDay (value) {
      this.fields.date = value
      this.timesOfDay = this.loadData[value].times
      this.fields.time = this.timesOfDay[this.fields.time]
      this.$v.fields.date.$touch()
      this.$v.fields.time.$touch()
    },
    submitForm () {
      let data = objectToFormData({
        ...this.fields,
        imei: this.serialNumber,
        status: this.info ? 'edited' : 'active'
      })
      this.info && data.append('code', this.info.code)
      api
        .post(`/ajax.php?action=sg:service.api.videocall.${this.info ? 'update' : 'add'}`, data)
        .then(response => {
          if (response.data.status === 'success') {
            !this.info
              ? this.$router.push({ name: 'video-success', params: { info: {code: response.data.data, ...this.fields, imei: this.serialNumber} } })
              : this.$router.push({ name: 'video-success', params: { info: {code: this.info.code, ...this.fields, imei: this.serialNumber} } })
          }
        })
    }
  },
  computed: {
    ...mapGetters({
      callInfo: 'getVideoCall'
    })
  },
  components: {
    TextInput
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Video/bookVideo.vue